export default __webpack_public_path__ + "static/media/Avatar.e83318b0.svg";